{
  "sources": "Sources",
  "prompt": "Write a prompt to start chatting with the assistant",
  "assistant": "Assistant",
  "assistantPlaceholder": "Type here, use Shift + Return to add a new line",
  "audio": "Do you want audio?",
  "return-line": "Return to add a new line",
  "send": "Send",
  "record": "Record",
  "recording": "Recording",
  "promptSelector": "Assistant prompt",
  "promptDefault": "Default",
  "promptLoading": "Loading custom prompts...",
  "promptEmpty": "No custom prompts available. Using the default assistant behavior.",
  "promptUnavailable": "Custom prompts are unavailable. Using the default assistant behavior.",
  "promptInitializationError": "The assistant could not initialize. Using the default assistant behavior.",
  "promptChangeTitle": "Change assistant prompt",
  "promptChangeTitleWithName": "Change assistant prompt to \"{{name}}\"",
  "promptChangeMessage": "Changing the prompt will clear the current conversation. Do you want to continue?",
  "promptChangeConfirm": "Yes, change",
  "promptChangeDescriptionLabel": "Prompt description",
  "promptDescriptionUnavailable": "No description is available for this prompt.",
  "aiConfig:promptName": "Prompt Name",
  "aiConfig:promptModel": "Model",
  "aiConfig:actions": "Actions",
  "aiConfig:editPrompt": "Edit Prompt",
  "aiConfig:delete": "Delete",
  "aiConfig:confirmDelete": "Are you sure you want to delete this prompt?",
  "showThoughts": "Show thoughts",
  "hideThoughts": "Hide thoughts",
  "showToolCalls": "Show tool calls ({{count}})",
  "hideToolCalls": "Hide tool calls ({{count}})",
  "showSubAgentWork": "Show subagent work ({{count}})",
  "hideSubAgentWork": "Hide subagent work ({{count}})"
}
